
import { Union, Record } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { BusinessUnitOverviewDto_$reflection } from "../../Shared/BusinessUnit.js";
import { union_type, class_type, record_type, list_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { AccountSettings_$reflection, RequestedValue$1_$reflection } from "../../Shared/Shared.js";

export class State extends Record {
    constructor(BusinessUnits, AccountSettings) {
        super();
        this.BusinessUnits = BusinessUnits;
        this.AccountSettings = AccountSettings;
    }
}

export function State_$reflection() {
    return record_type("BusinessUnit.Overview.Types.State", [], State, () => [["BusinessUnits", RequestedValue$1_$reflection(list_type(BusinessUnitOverviewDto_$reflection()))], ["AccountSettings", RequestedValue$1_$reflection(AccountSettings_$reflection())]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["BusinessUnitsFetched", "AccountSettingsFetched", "FetchError"];
    }
}

export function Msg_$reflection() {
    return union_type("BusinessUnit.Overview.Types.Msg", [], Msg, () => [[["Item", list_type(BusinessUnitOverviewDto_$reflection())]], [["Item", AccountSettings_$reflection()]], [["Item", class_type("System.Exception")]]]);
}

